import React, { useState } from "react";
// import { IStructure } from "../../store/Structure/type";
import { IUser } from "../store/User/type";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  MenuItem,
  Button,
} from "@mui/material";
import Menu, { MenuProps } from "@mui/material/Menu";
import { styled, alpha } from "@mui/material/styles";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import BootstrapDialog from "./BootStrapDialog";
import BootstrapDialogTitle from "./BootstrapDialogTitle";

const StyledMenu = styled((props) => (
  <Menu
    id="long-menu"
    MenuListProps={{
      "aria-labelledby": "long-button",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    minWidth: 100,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        // marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export const CustomizedMenusUser = (props) => {
  const { onDelete, setUser, setView } = props;
  const [anchorEl, setAnchorEl] =
    (React.useState < null) | (HTMLElement > null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disableElevation
        size={"small"}
        onClick={handleClick}
      >
        <i className="fa fa-ellipsis-h fa-lg" aria-hidden="true" />
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {setView ? (
          <MenuItem
            onClick={() => {
              handleClose();
              setView(true);
              setUser();
            }}
          >
            Details
          </MenuItem>
        ) : null}
        <MenuItem
          onClick={() => {
            handleClose();
            onDelete();
          }}
        >
          Delete
        </MenuItem>
      </StyledMenu>
    </div>
  );
};
export const ReviewUser = (props) => {
  const { user, setView, view } = props;
  return (
    <div className="container-fluid ">
      <BootstrapDialog
        onClose={() => setView(false)}
        fullWidth={true}
        aria-labelledby="customized-dialog-title"
        open={view}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => setView(false)}
        >
          <span className="mediumSize">User Info</span>
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <div className="p-2 row">
            <div className="col bg-white ">
              <div className="row mb-3">
                <div className="col-md-4">
                  <label>Names</label>
                </div>
                <div className="col-md-8 fw-bolder">
                  <label>{user?.UserInfo?.names}</label>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-4">
                  <label>Email</label>
                </div>
                <div className="col-md-8 fw-bolder">
                  <label>{user?.email}</label>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <label>Appointment</label>
                </div>
                <div className="col-md-8 fw-bolder">
                  <label>{user?.Position?.name}</label>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-4 text-capitalize">
                  <label>{user?.Structure?.type}</label>
                </div>
                <div className="col-md-8 fw-bolder">
                  <label>{user?.Structure?.name}</label>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-4">
                  <label>Phone Number</label>
                </div>
                <div className="col-md-8 fw-bolder">
                  <label>{user?.UserInfo?.phoneNumber}</label>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-4">
                  <label>Service Number</label>
                </div>
                <div className="col-md-8 fw-bolder">
                  <label>{user?.UserInfo?.identifierNumber}</label>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-4">
                  <label>National ID</label>
                </div>
                <div className="col-md-8 fw-bolder">
                  <label>{user?.UserInfo?.nationalId}</label>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus color={"error"} onClick={() => setView(false)}>
            Close
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};
const Approver = (props) => {
  const { selectedUsers, removeUser, deletable } = props;
  const [view, setView] = useState(false);
  const [user, setUser] = useState();

  return (
    <div className="row mb-3">
      <div className="col-12">
        <div className="row mb-3">
          <div className="col">
            <ReviewUser user={user} view={view} setView={setView} />
            <Table size={"small"}>
              <TableHead>
                <TableRow>
                  {["Level", "Names", "Email", "Role", "Action"].map(
                    (title) => (
                      <TableCell className="fw-bold">{title}</TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedUsers?.map((user) => (
                  <TableRow>
                    <TableCell>{user?.Structure?.name}</TableCell>
                    <TableCell>{user?.UserInfo?.names}</TableCell>
                    <TableCell>{user?.email}</TableCell>
                    <TableCell className="text-capitalize">
                      {user?.Position?.name}
                    </TableCell>
                    <TableCell>
                      <CustomizedMenusUser
                        setView={setView}
                        setUser={() => {
                          setUser(user);
                        }}
                        onDelete={() => {
                          removeUser(user);
                        }}
                        deletable={false}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Approver;
